import {CrudModel} from '@ngx-ivengi/crud';
import {IFormSelectOption} from '@brands-compart/form-wizard';

export class Product extends CrudModel implements IFormSelectOption {

  public name: string;
  public productGroup: string;

  public setName(name: string): Product {
    if(typeof name === 'string') {
      this.name = name;
    }
    return this;
  }

  public setProductGroup(productGroup: string): Product {
    if(typeof productGroup === 'string') {
      this.productGroup = productGroup;
    }
    return this;
  }

  fromResponse(response: any): void {
    this
      .setId(response.id)
      .setName(response.name)
      .setProductGroup(response.productGroup);
  }

  toKeyValueOption(): {label: string; value: any} {
    return {
      label: this.name,
      value: this.id
    };
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/product/product.model.ts